"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var utils_1 = require("../../utils");
var FlashMessages_1 = require("./context/FlashMessages");
var ErrorFlashMessages = function () {
    var _a = react_1.useState(false), started = _a[0], setStarted = _a[1];
    var _b = FlashMessages_1.useFlashMessages(), messages = _b.messages, resetErrorMessage = _b.resetErrorMessage;
    react_1.useEffect(function () {
        if (!started && messages.error) {
            setStarted(true);
            utils_1.flash(messages.error, utils_1.AlertType.DANGER, function () {
                resetErrorMessage();
                setStarted(false);
            });
        }
    }, [messages.error]);
    return null;
};
exports.default = ErrorFlashMessages;
//# sourceMappingURL=ErrorFlashMessages.js.map